export { PersonAttributeTypes } from './personAttributeTypes.component';
